/**
 * API base URL.
 *
 * - Development: empty string — requests go through Vite's dev proxy ("/api/…").
 * - Production: set VITE_API_URL via Cloudflare Pages environment variables
 *   to the full Worker URL (e.g. "https://pia-worker.caldere.workers.dev").
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL || "";
